export default __webpack_public_path__ + "static/media/logo1.22c7c376.svg";